import React from "react"
import MenuIcon from "../../assets/images/burger-menu-icon.svg?react"

import classNames from "classnames"
import "./BurgerMenu.scss"

interface BurgerMenuProps {
  handleBurgerClicked: () => void
  className?: string
}

export const BurgerMenu: React.FC<BurgerMenuProps> = ({
  handleBurgerClicked,
  className: classNameComingFromParent,
}) => {
  const handleKeyUp = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === "Enter" || event.key === "Space") {
      handleBurgerClicked()
    }
  }

  return (
    <button
      className={classNames("burger-menu", classNameComingFromParent)}
      onClick={handleBurgerClicked}
      onKeyUp={handleKeyUp}
    >
      <MenuIcon width={20} height={20} />
    </button>
  )
}
